exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".welcomepage {\n  width: 100%;\n  height: 100%;\n}\n.navigator .left img.trigger {\n  height: 50px;\n  z-index: 1;\n}\n.navigator .left img.logo {\n  position: absolute;\n  width: 30px;\n  top: 10px;\n  left: 18px;\n  z-index: -1;\n}\n", ""]);

// exports
